import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import {List} from 'immutable';

import Icon from 'web-app/react/components/icons/legacy/icon';
import {IconPropType} from 'web-app/react/components/icons/legacy/icon';
import {media} from 'web-app/styleguide/utils';
import ActionSheet, {shouldUseActionSheet} from 'web-app/react/components/action-sheet/action-sheet';
import {PortalRootId} from 'web-app/react/components/portals/constants';

import Popover from './popover';
import PopoverRow from './popover-row';

const StyledIcon = styled(Icon)`
    height: ${props => (props.size ? `${props.size}px` : '15px')};
    width: ${props => (props.size ? `${props.size}px` : '15px')};
    vertical-align: sub;
    margin-right: 5px;

    ${media.mobile`
        margin-right: 10px;
    `}
`;

const ListPopover = props => {
    const {
        direction,
        className,
        alignContent,
        onClose,
        onClick,
        position,
        items,
        showArrow,
        iconSize,
        outsideClickIgnoreClass,
        actionSheetRootId,
    } = props;

    if (shouldUseActionSheet()) {
        return (
            <ActionSheet
                items={List(items)}
                handleClose={onClose}
                onItemClick={onClick}
                customRootId={actionSheetRootId}
            />
        );
    }

    return (
        <Popover
            showArrow={showArrow}
            direction={direction}
            className={className}
            onClickOutside={() => onClose()}
            position={position}
            outsideClickIgnoreClass={outsideClickIgnoreClass}
        >
            {items.map(item => {
                const rowProps = {
                    type: item.type,
                    position,
                    buttonId: item.id,
                    active: item.active,
                    href: item.href,
                    alignContent: alignContent ? alignContent : undefined,
                    disabled: item.disabled,
                };
                if (onClick) {
                    rowProps.onClick = () => {
                        onClick(item);
                        onClose();
                    };
                }
                if (item.onClick) {
                    rowProps.onClick = () => {
                        item.onClick(item);
                        onClose();
                    };
                }

                return (
                    <PopoverRow {...rowProps} key={item.id}>
                        {item.icon && <StyledIcon icon={item.icon} size={iconSize} />}
                        {item.listTitle ? item.listTitle : item.title}
                    </PopoverRow>
                );
            })}
        </Popover>
    );
};

ListPopover.propTypes = {
    outsideClickIgnoreClass: PropTypes.string,
    direction: PropTypes.oneOf(['NORTH', 'SOUTH']),
    iconSize: PropTypes.number,
    className: PropTypes.string,
    onClose: PropTypes.func,
    onClick: PropTypes.func,
    position: PropTypes.oneOf(['right', 'left', 'center']),
    alignContent: PropTypes.string,
    actionSheetRootId: PropTypes.oneOf(Object.values(PortalRootId)),
    items: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.string.isRequired,
            title: PropTypes.string.isRequired,
            listTitle: PropTypes.string,
            disabled: PropTypes.bool,
            // onClick is optional. If defined it takes precedence over
            // the 'top-level' onClick handler
            onClick: PropTypes.func,
            type: PropTypes.string,
            icon: IconPropType,
        }),
    ),
    showArrow: PropTypes.bool,
};

export default ListPopover;
